import { Text } from 'hb-react/shared/components/formik/components/inputs';

export const Title = () => (
  <Text
    id="title"
    label={s__('JobForm|Title')}
    name="title"
    placeholder={s__('JobForm|Title of the opportunity')}
    validate={{ required: true }}
  />
);
